import axiosClient from "./axiosClient";

const preFix = '/inv-goods';
const inventoryApi = {

    getInventoryGoods(params) {
        const url = `${preFix}`;
        return axiosClient.get(url, { params: params });
    },
    getInventoryGoodsInfo(params) {
        const url = `${preFix}/info`;
        return axiosClient.get(url, { params: params });
    },
    addNewInvGoods(params) {
        const url = `${preFix}/new`;
        return axiosClient.post(url, params, {
            headers: {
                "Content-Type": "multipart/form-data",
            },
        });
    },
    updateInvGoods(params) {
        const url = `${preFix}/upd`;
        return axiosClient.post(url, params, {
            headers: {
                "Content-Type": "multipart/form-data",
            },
        });
    },
    deleteInventoryGoods(params) {
        const url = `${preFix}/del`;
        return axiosClient.post(url, params);
    },
    changeInvGoodsStockQ(params) {
        const url = `${preFix}/change-stock-q`;
        return axiosClient.post(url, params);
    },
    deleteInventoryHistory(params) {
        const url = `${preFix}/del-history`;
        return axiosClient.post(url, params);
    },

    updateInventoryHistory(params) {
        const url = `${preFix}/udp-history`;
        return axiosClient.post(url, params);
    },
}

export default inventoryApi;
